import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import styled from 'styled-components';

import Navbar from './Navbar';
import { NavbarCollapsedProvider, useNavbarCollapsed } from './State';


const LayoutContainer = styled.div`
  display: grid;
  height: 100dvh;
  margin: auto;
  position: relative;
`;

const Container = styled.div`
  display: grid;
  grid-template-columns: ${props => props.$collapsed ? '52px' : '220px'} 1fr;
  min-width: 0;
  transition: grid-template-columns 0.2s ease;
`;

const Content = styled.div`
  background: #FBFBFB;
  display: grid;
  height: 100dvh;
  min-width: 0;
  overflow: hidden;
`;


function DashboardLayout({ topToolbar, bottomToolbar, menu, navbarProps, children }) {
  const { navbarCollapsed, toggleNavbarCollapsed } = useNavbarCollapsed();

  const onToggleCollapse = useCallback(() => {
    toggleNavbarCollapsed();
  }, [toggleNavbarCollapsed]);

  return (
    <LayoutContainer
      id={'dashboard-container'}
    >
      <Container $collapsed={navbarCollapsed}>
        <Navbar
          topToolbar={topToolbar}
          bottomToolbar={bottomToolbar}
          navbarProps={navbarProps}
          menu={menu}
          collapsed={navbarCollapsed}
          onToggleCollapse={onToggleCollapse}
        />
        <Content id={'DashboardContent'}>
          {children}
        </Content>
      </Container>
    </LayoutContainer>
  );
}

function Dashboard(props) {
  return (
    <NavbarCollapsedProvider>
      <DashboardLayout {...props} />
    </NavbarCollapsedProvider>
  );
}

Dashboard.propTypes = {
  topToolbar: PropTypes.element,
  bottomToolbar: PropTypes.element,
  navbarProps: PropTypes.object,
};

export default Dashboard;
